export const searchOrganizationFragment = `
title
text
url
`;
